// exports.onClientEntry = () => {
// require('typeface-cooper-hewitt');
// require('typeface-playfair-display');
// }
require('typeface-cooper-hewitt');
require('typeface-playfair-display');
